// IMPORTANT — Security reminder:
// This client uses the anon key and is subject to Row Level Security (RLS) policies.
// Never use this client with the service role key. All tables accessed from the browser
// must have RLS enabled and appropriate policies configured in Supabase.
import { createBrowserClient as createSupabaseBrowserClient } from '@supabase/ssr'
import { supabaseConfig } from './config'

let _client: ReturnType<typeof createSupabaseBrowserClient> | null = null

export function getBrowserSupabase() {
  if (_client) return _client
  _client = createSupabaseBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { auth: supabaseConfig.auth }
  )
  return _client
}

/** Canonical browser Supabase client. Use createClient() everywhere. */
export function createClient() {
  return getBrowserSupabase()
}
